export default {
    navigationBarTitleText: "施工进度",
  };
  